module.exports = __webpack_public_path__ + "images/website-online-presence-300w.jpg";